import { render, staticRenderFns } from "./LapTechnicianProfile.vue?vue&type=template&id=ac5238a4"
import script from "./LapTechnicianProfile.vue?vue&type=script&lang=js"
export * from "./LapTechnicianProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports